import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import RecordTypesHandler from '@/mixins/record-types'
import DocuSignDialog from '@/modules/Policy/components/DocuSignDialog.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import SearchAccount from '@/mixins/search-queries/search-account'
import { getDocusignEnvelope, editDocusignEnvelope, deleteDocusignEnvelope, sendDocusignEnvelope, voidDocusignEnvelope, resendDocusignEnvelope } from '@/modules/Envelop/gql/envelop.gql'
import AddFileDialog from '@/modules/Envelop/components/AddFileDialog.vue'
import { DocusignEnvelope } from '@/modules/Envelop/interfaces/envelop-detail'
import { getUsers } from '@/modules/User/gql/user.gql'
import { getContacts } from '@/modules/Contact/gql/contact.gql'
import S3Handler from '@/mixins/s3'
import AppFilePreview from '@/components/AppFilePreview.vue'
import AppLoader from '@/components/AppLoader.vue'

@Component({
  components: {
    AppBreadcrumbs,
    AppDialog,
    AppTextarea,
    AppTextSearch,
    AddFileDialog,
    AppFilePreview,
    AppLoader
  }
})

export default class EnvelopDetail extends mixins(DocuSignDialog, RecordTypesHandler, SearchAccount, S3Handler) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Insurance Cases'
    },
    {
      text: 'Policies',
      exact: true,
      to: { name: 'PoliciesList' }
    }
  ]

  windowSize = {
    w: 0,
    h: 0,
    cW: 0
  }

  // 禁用send
  disabledSend = false
  recipientsLoading = false
  fileListLoading = false
  canEdit = false
  showEdit = false
  attachmentListLoading = false
  isLoading = false

  // envelope
  envelope: DocusignEnvelope | null = null

  // 信封表单
  envelopForm: { [k: string]: any } = {}

  users = []

  recipients: any = []

  fileList: any = []

  deleteDialog: { [key: string]: any } = {
    show: false
  }

  resendDialog = {
    title: 'Resend Envelope',
    show: false
  }

  voidDialog = {
    title: 'Void Envelope ',
    show: false,
    voidedReason: ''
  }

  addFileDialog = {
    show: false
  }

  deleteEnvelopDialog = {
    show: false
  }

  fileTableColumn = [
    {
      field: 'name',
      title: 'File Name'
    },
    {
      field: 'originUrl',
      title: 'Origin Url',
      slots: {
        default: 'origin_url'
      }
    },
    {
      field: 'signedUrl',
      title: 'Signed Url',
      slots: {
        default: 'signed_url'
      }
    },
    {
      field: 'type',
      title: 'File Type'
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action' }, fixed: 'right', width: 90 }

  ]
  recipientsTableColumn = [
    { field: 'recipient.name', title: 'Name' },
    { field: 'recipient.email', title: 'Email' },
    { field: 'signStatus', title: 'Sign Status', slots: { default: 'signStatus' } }
  ]

  optionalEmails = []

  get disableAll () {
    return this.showEdit
  }
  // vergeStaff options
  get userOptions () {
    return this.users.map((item: any) => {
      return {
        id: item.id,
        name: item.username
      }
    })
  }

  get showVoid () {
    const { envelope } = this
    return envelope && envelope.status === 'sent'
  }

  async mounted () {
    const { id, type } = this.$route.params
    this.showEdit = type !== 'edit'
    this.getUsers()
    await this.getEnvelopeById()
    this.breadcrumbs.push({
      text: `${this.envelopForm.subject} (Envelop ID: ${id})`
    })
  }

  @Watch('fileList', { deep: true })
  fileListChange (val: any) {
    if (val.length !== 0 && this.showEdit) {
      this.disabledSend = false
    } else {
      this.disabledSend = true
    }
  }

  @Watch('showEdit')
  editChange (val: any) {
    if (this.fileList.length !== 0 && val) {
      this.disabledSend = false
    } else {
      this.disabledSend = true
    }
  }

  @Watch('$route', { deep: true })
  async onRouteParamUpdate (val: any) {
    const { id } = val.params
    this.breadcrumbs.pop()
    await this.getEnvelopeById()
    this.breadcrumbs.push({
      text: `${this.envelopForm.subject} (Envelop ID: ${id})`
    })
  }

  // 查询信封by id
  async getEnvelopeById () {
    this.recipientsLoading = true
    this.fileListLoading = true
    this.isLoading = true
    const { optionalEmails } = this
    const { id } = this.$route.params

    try {
      const result = await this.$apollo.query({
        query: getDocusignEnvelope,
        variables: {
          envelopeId: +id
        }
      })
      this.recipientsLoading = false
      this.fileListLoading = false
      if (result.data) {
        this.envelope = result.data.getDocusignEnvelope as DocusignEnvelope
        const { clientName, clientEmail, ccName, ccEmail, message, subject, signers, documents, vergeStaff, status, account: { id: accoutId, name } } = this.envelope
        // 表单赋值
        this.envelopForm.client = name
        this.envelopForm.clientName = clientName
        this.envelopForm.ccName = ccName
        this.envelopForm.ccEmail = ccEmail
        this.envelopForm.message = message
        this.envelopForm.subject = subject
        this.recipients = signers
        this.fileList = documents

        this.canEdit = status === 'draft'
        // staff赋值
        if (vergeStaff) {
          const { id, username } = vergeStaff
          this.envelopForm.vergeStaff = {
            id: id,
            name: username
          }
        } else {
          this.envelopForm.vergeStaff = null
        }
        // templateIds和acordFormIds赋值
        this.envelopForm.acordFormIds = []
        this.envelopForm.templateIds = []
        documents.forEach((item: any) => {
          if (item.type === 'TEMPLATE') {
            this.envelopForm.templateIds.push(+item.originId)
          } else {
            this.envelopForm.acordFormIds.push(+item.originId)
          }
        })

        if (clientEmail) {
          this.envelopForm.clientEmail = clientEmail
        } else {
          await this.getEmails(+accoutId)
        }
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }

    this.isLoading = false
  }
  // 确认添加文件
  confirmAddFileDialog (val: any) {
    const { type, fileInfo } = val
    if (val.type === 'TEMPLATE') {
      this.envelopForm.templateIds.push(Number(fileInfo.id))
    } else {
      this.envelopForm.acordFormIds.push(Number(fileInfo.id))
    }
    this.fileList.push({ 'type': type, ...fileInfo })
  }
  // 取消
  async handleCancel () {
    this.showEdit = true
    await this.getEnvelopeById()
    this.resetForm()
  }
  // 编辑
  async handleEdit () {
    this.isLoading = true
    if (!this.showEdit && this.envelope) {
      if (this.validateForm()) {
        const { subject, vergeStaff, clientEmail, clientName, message, templateIds, acordFormIds, ccEmail, ccName } = this.envelopForm
        const accountId = this.envelope.account.id
        try {
          const result = await this.$apollo.mutate({
            mutation: editDocusignEnvelope,
            variables: {
              envelopeId: +this.$route.params.id,
              input: {
                accountId: +accountId,
                subject,
                vergeStaffId: +vergeStaff.id,
                clientEmail,
                clientName,
                ccEmail,
                ccName,
                message,
                templateIds,
                acordFormIds,
                templateParams: []
              }
            }
          })
          if (result.data) {
            showNotification({
              msg: 'Save Successful!',
              type: SnackType.Success
            })
            this.getEnvelopeById()
            this.showEdit = !this.showEdit
          }
        } catch (e) {
          showErrors(e.graphQLErrors)
        }
      } else {
        this.isLoading = false
        return false
      }
    } else {
      this.showEdit = !this.showEdit
    }
    this.isLoading = false
  }

  // 删除事件
  handleDelete (row: any, type: string, title: string) {
    this.deleteDialog.type = type
    if (this.deleteDialog.type === 'file' && this.disableAll) {
      this.deleteDialog.show = false
    } else {
      this.deleteDialog.show = true
      this.deleteDialog.row = row
      this.deleteDialog.title = title
    }
  }
  // 确认删除
  deleteConfirm () {
    this.isLoading = true
    if (this.deleteDialog.type === 'file') {
      if (this.deleteDialog.row['type'] === 'TEMPLATE') {
        const delIndex = this.envelopForm.templateIds.findIndex((item: number) => {
          return item === Number(this.deleteDialog.row['id'])
        })
        this.envelopForm.templateIds.splice(delIndex, 1)
      } else {
        const delIndex = this.envelopForm.acordFormIds.findIndex((item: number) => {
          return item === Number(this.deleteDialog.row['id'])
        })
        this.envelopForm.acordFormIds.splice(delIndex, 1)
      }
      const index = this.fileList.findIndex((item: any) => {
        return this.deleteDialog.row['id'] === item.id
      }
      )
      this.fileList.splice(index, 1)
    } else {
      this.deleteEnvelop()
    }
    this.deleteDialog.show = false
    this.isLoading = false
  }

  async handleSendOrResend () {
    const { envelope } = this
    if (!envelope) {
      return
    }
    if (envelope.status === 'draft') {
      await this.handleSend()
    } else {
      await this.handleResend()
    }
  }
  // 发送
  async handleSend () {
    const { envelope } = this
    if (!envelope) {
      return
    }
    this.isLoading = true
    try {
      const result = await this.$apollo.mutate({
        mutation: sendDocusignEnvelope,
        variables: {
          envelopeId: +envelope.id
        }
      })
      if (result.data.sendDocusignEnvelope) {
        showNotification({
          msg: 'Send Successful!',
          type: SnackType.Success
        })
        this.$router.go(-1)
      } else {
        showNotification({
          msg: 'Send Failed!',
          type: SnackType.Error
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
    this.isLoading = false
  }
  // 删除信封
  async deleteEnvelop () {
    const { envelope } = this
    if (!envelope) {
      return
    }
    this.isLoading = true
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteDocusignEnvelope,
        variables: {
          envelopeId: +envelope.id
        }
      })
      if (result.data.deleteDocusignEnvelope) {
        showNotification({
          msg: 'Delete Successful!',
          type: SnackType.Success
        })
        this.$router.go(-1)
      } else {
        showNotification({
          msg: 'Delete Failed!',
          type: SnackType.Error
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
    this.isLoading = false
  }
  // staff查询
  async getUsers (val?: any) {
    try {
      const result = await this.$apollo.query({
        query: getUsers,
        variables: {
          filter: {
            username: val
          }
        }
      })
      if (!result.data) {
        return
      }
      this.users = result.data.getUsers.users
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  // 获取联系人邮箱
  async getEmails (accountId: number) {
    try {
      const result = await this.$apollo.query({
        query: getContacts,
        variables: {
          filter: {
            accountId
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      const contacts = result.data.getContacts.contacts

      for (const contact of contacts) {
        if (contact.email) {
          this.envelopForm.clientEmail = contact.email
          break
        }
        if (contact.otherEmail) {
          this.envelopForm.clientEmail = contact.otherEmail
          break
        }
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  // select staff
  selectUserHandler (val: number) {
    if (!val) {
      return false
    }
    const { id, username } = this.users[val - 1]
    const selected = {
      id: id,
      name: username
    }
    if (!selected) {
      return false
    }
    this.envelopForm.vergeStaff = selected
  }
  // 重置表单
  resetForm () {
    (this.$refs.form as Vue & { resetValidation(): void }).resetValidation()
  }
  // 表单验证
  validateForm () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }

  handleCorrect () { }
  handleSign () { }
  onResize () {
    const container = this.$refs.container as Vue & { clientWidth: number }
    this.windowSize = { w: window.innerWidth, h: window.innerHeight, cW: container.clientWidth }
  }

  async downloadFileHandler (url: string) {
    showNotification({
      msg: 'File downloading will start soon, please wait!',
      type: SnackType.Success
    })
    if (!this.checkCredentialValid()) {
      await this.getSTSCredentials()
    }
    this.attachmentListLoading = true
    const arr = url.split('/')
    await this.downloadFileFromS3(url, arr[arr.length - 1])
    this.attachmentListLoading = false
  }

  handleResend () {
    this.resendDialog.show = true
  }

  // 重新发送
  async handleResendConfirm () {
    const { envelope } = this
    this.resendDialog.show = false
    if (!envelope) {
      return
    }
    this.isLoading = true
    try {
      const result = await this.$apollo.mutate({
        mutation: resendDocusignEnvelope,
        variables: {
          envelopeId: +envelope.id
        }
      })
      if (result.data.resendDocusignEnvelope) {
        showNotification({
          msg: 'Resend Successful!',
          type: SnackType.Success
        })
        this.$router.go(-1)
      } else {
        showNotification({
          msg: 'Resend Failed!',
          type: SnackType.Error
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
    this.isLoading = false
  }

  handleVoid () {
    this.voidDialog.show = true
  }

  // 作废邮件
  async handleVoidConfirm () {
    const { envelope } = this
    const { voidedReason } = this.voidDialog
    this.voidDialog.show = false
    this.voidDialog.voidedReason = ''
    if (!envelope) {
      return
    }
    this.isLoading = true
    try {
      const result = await this.$apollo.mutate({
        mutation: voidDocusignEnvelope,
        variables: {
          envelopeId: +envelope.id,
          voidedReason
        }
      })
      if (result.data.voidDocusignEnvelope) {
        showNotification({
          msg: 'Void Successful!',
          type: SnackType.Success
        })
        this.$router.go(-1)
      } else {
        showNotification({
          msg: 'Void Failed!',
          type: SnackType.Error
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
    this.isLoading = false
  }

  async resetVoidForm () {
    this.voidDialog.show = false
    this.voidDialog.voidedReason = ''
  }
}
